<template>
    <div class="products-setup">
        <div class="step-title">{{ $t('products.import.title') }}</div>

        <products-import
            ref="productsImport"
            :type-of-import="'generalImport'"
            mode="getstarted"
            @import="onProductsImported($event)"
            @error="onProductsImportFailed"
        />

        <div class="footer">
            <v-btn
                class="flex-1 mr-3"
                color="#282b38"
                depressed
                @click="skipImport()"
            >
                {{ $t('general.skip') }}
            </v-btn>
            <v-btn
                class="flex-1"
                color="primary"
                depressed
                :disabled="busy"
                :loading="busy"
                @click="importProducts"
            >
                {{ $t('general.import') }}
            </v-btn>
        </div>
    </div>
</template>

<script>
import * as mutationTypes from '@/store/mutationTypes'
import ApiService from '@/services/ApiService'
import ProductsImport from '@/views/shared/components/ProductsImport'

export default {
    components: {
        ProductsImport
    },

    data() {
        return {
            busy: false,
            productsTable: null,
            failedProducts: [],
            categories: [],
        };
    },

    methods: {
        /**
         * Skip importing products
         */
        skipImport() {
            ApiService.post('/getstarted/products/import', null).then(response => {
                this.$emit('finish')
            });
        },

        /**
         * Import products
         */
        async importProducts() {
            this.busy = true
            await this.$refs.productsImport.importFile()
            this.busy = false
        },

        /**
         * On Product Import Finished
         */
        onProductsImported(data) {
            this.$store.commit(mutationTypes.SET_TENANT, { tenant: data.tenant });
            this.$emit('finish')
        },

        /**
         * On Product Import Error
         */
        onProductsImportFailed() {
            this.$snackbar(this.$t('products.import.fail'), 'error');
        },
    },
};
</script>

<style lang="scss" scoped>
.products-setup {
    padding-bottom: 50px;

    .step-title {
        margin-bottom: 10px;
        font-size: 20px;
    }

    .footer {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
}
</style>
